var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.groups),function(group){return _c('KCheckbox',{key:group.id,attrs:{"label":group.name,"checked":_vm.groupIsSelected(group)},on:{"change":function($event){return _vm.toggleGroup($event, group)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }